// La carte des personnalités (16 octobre 2026) : un système solaire par mouvement.
// Jamais un nombre de mentions ni d'auteurs : des parts. Jamais de genre deviné
// (« ceux qui parlent de {a} », jamais « de lui »). Jamais la façon de mesurer.
// Les pourcentages passent par `commun.pourcent`.
export default {
  vue: { aria: 'Affichage de l’annuaire', liste: 'Liste', carte: 'Carte' },
  sousTitre: '{n} personnalités en {systemes} systèmes, de la gauche à la droite de l’hémicycle',
  chargement: 'La carte se dessine…',
  vide: 'Aucune personnalité dans l’annuaire de ce pays pour l’instant.',
  scene: {
    galaxie: 'La galaxie des mouvements : un système par mouvement, les personnalités suivies reliées par leur public commun',
    systeme: 'Le système {nom} : ses personnalités en orbite, par rang',
  },
  kicker: 'Galaxie politique · {pays}',
  titre: { galaxie: 'Un système par mouvement' },
  // Le nombre de personnalités d'un système : jamais de mentions.
  effectif: '{n} personnalité | {n} personnalité | {n} personnalités',
  repere: { gauche: 'Gauche', droite: 'Droite' },
  soleil: {
    aria: '{sigle}, {nom} : {effectif}. Entrer dans le système',
    centre: 'autour de {nom}',
  },
  systeme: {
    retour: 'Toute la galaxie',
    retourAria: 'Revenir à toute la galaxie',
    sansCentre: 'sans astre central : l’annuaire ne les rattache à aucun mouvement',
  },
  orbite: {
    direction: 'Direction',
    executif: 'Exécutif',
    territoires: 'Régions et villes',
    europe: 'Parlement européen',
    AN: 'Assemblée nationale',
    SENAT: 'Sénat',
    autre: 'Autres mandats',
  },
  // Ce que l'annuaire ne range dans aucun mouvement : les noms de ces systèmes se traduisent.
  residuel: {
    gouvernement: { sigle: 'Gouv.', nom: 'Gouvernement' },
    territoires: { sigle: 'Rég.', nom: 'Régions et grandes villes' },
    'non-inscrits': { sigle: 'NI', nom: 'Non-inscrits' },
    autres: { sigle: 'Autres', nom: 'Autres formations' },
    'sans-etiquette': { sigle: '?', nom: 'Sans étiquette connue' },
  },
  planete: {
    suivie: 'Suivie',
    centre: 'Astre central',
    ouvrir: '{nom}. Ouvrir la fiche',
    ouvrirSuivie: '{nom}, suivie. Voir sa note et son public',
  },
  legende: {
    aria: 'Légende de la carte',
    soleil: 'Un mouvement, de la taille de son nombre de personnalités',
    suivie: 'Personnalité suivie',
    tete: 'Tête du mouvement',
    lien: 'Public en commun : plus le trait est épais, plus il est partagé',
    orbites: 'Dans un système, du centre vers le dehors : l’astre central (la tête du mouvement), la direction, l’exécutif, les régions et les villes, le Parlement européen, l’Assemblée, le Sénat.',
  },
  suivies: {
    titre: 'Vos suivies',
    aucune: 'Suivez une personnalité depuis la liste ou sa fiche : elle s’allume ici, reliée à celles qui partagent son public.',
    ecouteFermee: 'Les publics en commun se lisent avec le suivi des personnalités.',
    liens: 'Aucun public en commun entre vos suivies pour l’instant | Un public en commun entre vos suivies | {n} publics en commun entre vos suivies',
  },
  panneau: {
    voirSysteme: 'Voir son système',
    ouvrirFiche: 'Ouvrir la fiche',
    ecouteFermee: 'Sa note, ceux qui en parlent et son public commun se lisent avec le suivi des personnalités.',
    note: 'Sa note',
    surCent: 'sur 100',
    evolution: '{n} sur 7 jours',
    sansNote: 'Pas encore de note : la première écoute est en cours.',
    personas: 'Ceux qui en parlent',
    aucunPersona: 'Les groupes de ceux qui en parlent se forment après quelques jours d’écoute.',
    portrait: 'Un visage du groupe « {nom} »',
    recoupements: 'Son public, en commun',
    recoupement: '{n} % de ceux qui parlent de {a} parlent aussi de {b}',
    inverse: 'et {n} % dans l’autre sens',
    personasProches: 'Personas proches',
    memePersona: '« {nom} » des deux côtés',
    deuxPersonas: '« {a} » et « {b} »',
    aucunRecoupement: 'Pas assez de public partagé avec vos autres suivies sur les {jours} derniers jours pour parler d’un public commun.',
    pasEncore: 'Pas encore assez d’écoute pour mesurer son public.',
    seule: 'Suivez une autre personnalité pour voir le public qu’elles partagent.',
  },
}
